import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import { Button } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
    },
}));

export default function TransitionsModal({ isOpen, setModalOpen }) {
    const classes = useStyles();
    const [open, setOpen] = React.useState(isOpen);

    const handleClose = () => {
        setModalOpen(false);
    };

    useEffect(() => {
        setOpen(isOpen);
    }, [isOpen])

    return (
        <div>
            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                className={classes.modal}
                open={open}
                onClose={handleClose}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 500,
                }}
            >
                <Fade in={open}>
                    <div className={classes.paper}>
                        <h2 id="transition-modal-title">Thank you for submitting your request.</h2>
                        <p id="transition-modal-description">Shortly you will  get a confirmation email on the given email, <br />and  will also be contacted by our compliance staff to continue with your appointment process. <br /> Please check your email inbox or your spam.</p>
                        <Button onClick={handleClose}>Close</Button>
                    </div>
                </Fade>
            </Modal>
        </div>
    );
}